// ============================================================
// Platform Control · OAuth Apps — provider registration state,
// redirect integrity, and install readiness.
// ============================================================

import { useNavigate } from 'react-router-dom'
import ViewShell, { Card, Row, Section, ActionButton, ActionRow } from './_ViewShell'
import EmptyState from '../../../components/EmptyState'
import { SHELL_TOKENS } from '../../../shell/styles'

function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text).catch(() => {})
}

export default function OAuthAppsView() {
  const navigate = useNavigate()

  return (
    <ViewShell
      kicker="PLATFORM CONTROL · OAUTH APPS"
      title="OAuth Apps"
      description="Provider registration state, redirect integrity, and install readiness."
    >
      <Section label="GITHUB">
        <Card>
          <Row label="App name" value="Supabase GitHub Provider" />
          <Row label="State" value="Code ready — requires operator setup" />
          <Row label="Powers" value="Social login via 'Continue with GitHub'" />
          <Row label="Scopes" value="user:email" />
          <Row label="Callback URL" value={<span style={{ fontSize: 10 }}>{'https://<project>.supabase.co/auth/v1/callback'}</span>} />
          <ActionRow>
            <ActionButton onClick={() => copyToClipboard('https://efdzlvtmbtbitrmotydi.supabase.co/auth/v1/callback')}>
              Copy Callback URL
            </ActionButton>
            <ActionButton onClick={() => window.open('https://github.com/settings/developers', '_blank')}>
              Open GitHub Developer Settings
            </ActionButton>
            <ActionButton onClick={() => navigate('/auth/login')}>
              Test GitHub Login
            </ActionButton>
          </ActionRow>
        </Card>
      </Section>

      <Section label="SLACK">
        <Card>
          <Row label="App name" value="Square Code Slack App" />
          <Row label="State" value="Manifest ready — requires workspace install" />
          <Row label="Powers" value="DISPATCH · approvals · operator loop" />
          <Row label="Scopes" value="app_mentions:read, chat:write, commands" />
          <ActionRow>
            <ActionButton onClick={() => window.open('https://api.slack.com/apps', '_blank')}>
              Open Slack App Settings
            </ActionButton>
            <ActionButton onClick={() => navigate('/square/control/integrations')}>
              Manage Slack Mappings
            </ActionButton>
          </ActionRow>
        </Card>
      </Section>

      <Section label="SUPABASE AUTH PROVIDERS">
        <Card>
          <Row label="Email/Password" value="Active" hint="hardened via POST /api/auth/login" />
          <Row label="GitHub OAuth" value="Config-blocked" hint="requires Supabase Dashboard setup" />
          <ActionRow>
            <ActionButton variant="primary" onClick={() => window.open('https://supabase.com/dashboard', '_blank')}>
              Open Supabase Dashboard
            </ActionButton>
          </ActionRow>
        </Card>
      </Section>
    </ViewShell>
  )
}
